var map = {
	"./webspecial_event_kirmes_cn.webm": 6322,
	"./webspecial_event_kirmes_de.webm": 388,
	"./webspecial_event_kirmes_en.webm": 6400,
	"./webspecial_event_kirmes_ja.webm": 7726
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2086;